import { Alert, AlertIcon } from "@chakra-ui/react";
import { Navigate } from "react-router";

import type { DTO } from "@equidefi/shared/types/dto";
import { EntityAccountTypeForm } from "./EntityAccountTypeForm";
import { JointAccountTypeForm } from "./JointAccountTypeForm";
import { TrustAccountTypeForm } from "./TrustAccountTypeForm";

type AccountTypeFormProps = {
  profile: DTO.SavedProfile;
  onSave: (values: Record<string, any>) => Promise<void>;
};

export const AccountTypeForm = ({ profile, onSave }: AccountTypeFormProps) => {
  if (!profile.account_type) {
    return (
      <Alert status="error">
        <AlertIcon />
        No account type set for this profile.
      </Alert>
    );
  }

  switch (profile.account_type) {
    case "INDIVIDUAL":
      // Individuals have no sub-type, so there is nothing to edit here.
      return (
        <Navigate
          to={profile.id ? `/vault/profile/saved-profiles/${profile.id}` : "/vault/profile/saved-profiles"}
          replace
        />
      );

    case "JOINT":
      return <JointAccountTypeForm profile={profile} onSave={onSave} />;

    case "ENTITY":
      return <EntityAccountTypeForm profile={profile} onSave={onSave} />;

    case "TRUST":
      return <TrustAccountTypeForm profile={profile} onSave={onSave} />;

    default: {
      const exhaustiveCheck: never = profile.account_type;
      throw new Error(`Unsupported account type: ${exhaustiveCheck}`);
    }
  }
};
